// react component called Services for Terms and Services page

const Services = () => {
  return (
    <div style={{ backgroundColor: "white" }}>
      <h1>Terms and Conditions</h1>
      <h5>Introduction</h5>
      <p>
        *1. Welcome to the BioMazze Coordination website, where we offer
        specialized biologic contract services to assist healthcare providers
        and practices in navigating the complexities of specialty medication
        authorization processes. By accessing and using our website, you agree
        to the following policy and terms and conditions.
      </p>
      <h5>Website Usage</h5>
      <p>
        *2. The BioMazze Coordination website is intended for informational
        purposes and to provide an overview of our biologic contract services.
        Users are prohibited from using the website for any unlawful or
        unauthorized purposes.
      </p>
    </div>
  );
};
export default Services;
